module.exports = __webpack_public_path__ + "static/media/anj-token.0e49844f.svg";